// 작업 실패 사유 남기기(SEO·한글표시) — 의존성 없는 순수 함수(시험: __tests__/seoErrorKeep.test.mjs).
// 예전엔 SEO 가 error 를 돌려줘도 workflowService 가 로그만 찍고 사유를 버려, 작업개시 결과가 «작업 실패: seo» 뿐이었다(PR261021-C21B60 · SEO 22건).
// 한글표시도 같았다 — «그리기 3분 안에 안 끝남» 사유가 결과에 안 실렸다(윈 3469 PR261021-359DEB).
// processError 는 견적서 몫(견적서 시작 때 비움 · «견적서가 멈춘 이유»)이라 따로 seoError·koreanLabelError{message, at} 에 둔다 — 상세이미지 detailImageWarning 과 같은 무늬.
// at = 실패 시각(다른 막힘 — 예: Wing 로그인 풀림 — 과는 시각으로만 대조한다 · 까닭을 지어 붙이지 않는다).

const MESSAGE_MAX = 300

// 상품에 저장할 칸 — 사유 글 그대로(없으면 «알 수 없는 오류») + 시각
function errorFields(key, message, now) {
  const text = message ? String(message).slice(0, MESSAGE_MAX) : '알 수 없는 오류'
  return { [key]: { message: text, at: now } }
}

// 그 작업이 error 일 때 이유 한 줄 — runWork·startQueue 결과의 reason 에 붙인다
function errorText(product, statusKey, errorKey) {
  if (!product) return undefined
  const s = product[statusKey]
  const status = s && typeof s === 'object' ? s.status : s
  if (status !== 'error') return undefined
  const e = product[errorKey]
  if (!e || typeof e !== 'object' || !e.message) return undefined
  return e.at ? `${String(e.message).slice(0, MESSAGE_MAX)} (${new Date(e.at).toISOString()})` : String(e.message).slice(0, MESSAGE_MAX)
}

export function seoErrorFields(message, now) {
  return errorFields('seoError', message, now)
}

export function seoErrorText(product) {
  return errorText(product, 'seoStatus', 'seoError')
}

export function koreanLabelErrorFields(message, now) {
  return errorFields('koreanLabelError', message, now)
}

export function koreanLabelErrorText(product) {
  return errorText(product, 'koreanLabelStatus', 'koreanLabelError')
}
